import $ from 'jquery';
import React, { Component } from 'react';
import * as Utils from 'app/blocks/common/utils';

function withChangesWatcher({ watchUnsavedChanges, unwatchUnsavedChanges }) {
    return function (WrappedComponent) {
        class Wrapper extends Component {
            constructor(props) {
                super(props);

                this.container = null;
                this.changesChecker = null;
                this.probablyMakeChanges = false;
            }

            componentDidMount() {
                $(this.container)
                    .on(
                        'input.watch-changes',
                        'input[data-seleniumid],input[id]:not([data-canchangestate="false"]),.Combobox input,input.date-picker__input',
                        this.markDirty,
                    )
                    .on(
                        'click.watch-changes',
                        'input[type="checkbox"],ul[id],.Combobox ul,.DayPicker-Day:not(.DayPicker-Day--disabled)',
                        this.markDirty,
                    )
                    .on('change.watch-changes', 'select', this.markDirty);

                watchUnsavedChanges(this);
            }

            componentWillUnmount() {
                $(this.container).off('.watch-changes');
                this.noChanges();
                unwatchUnsavedChanges(this);
            }

            hasUnsavedChanges = () => this.probablyMakeChanges || (this.changesChecker && this.changesChecker());

            noChanges = () => {
                this.probablyMakeChanges = false;
            };

            scrollTop = () => {
                Utils.scrollToElement($(this.container).closest('.panel'), 0);
            };

            markDirty = () => {
                this.probablyMakeChanges = true;
            };

            setChangesChecker = fn => {
                this.changesChecker = fn;
            };

            render() {
                return (
                    <div
                        ref={x => {
                            this.container = x;
                        }}
                        className="watch-changes-container"
                    >
                        <WrappedComponent
                            {...this.props}
                            hasUnsavedChanges={this.hasUnsavedChanges}
                            markDirty={this.markDirty}
                            noChanges={this.noChanges}
                            scrollTop={this.scrollTop}
                            setChangesChecker={this.setChangesChecker}
                        />
                    </div>
                );
            }
        }

        return Wrapper;
    };
}

export default withChangesWatcher;
